import React from 'react';
import { withTheme } from '@emotion/react';
import { ThemeProps } from '@theme/base';
import { Grid } from '@mui/material';
import { TripTypes, Page } from '@model/common';
import { TravelGuide } from '@model/content';
import { GuideLink } from '@components/common/next-link';
import { SimpleTile } from '@components/common/simple-tile';

export interface TravelGuideListProps extends ThemeProps {
  path: string;
  tripType?: TripTypes;
  guides: Array<TravelGuide>;
  destination?: string;
  testId?: string;
  className?: string;
  showList?: boolean;
}

export const TravelGuideListComponent = ({ path, guides, tripType, theme }: TravelGuideListProps) => {
  const renderTravelGuideTiles = () =>
    guides.map((travelGuide: TravelGuide) => {
      const { hero, title, shortDescription, targetPageConfigPath } = travelGuide;
      return (
        <Grid item xs={12} sm={6} lg={4} key={targetPageConfigPath}>
          <GuideLink path={path} guidePath={targetPageConfigPath} tripType={tripType} guidePage={Page.TRAVEL_GUIDES}>
            <SimpleTile title={title} shortDescription={shortDescription} imageUrl={hero.url} />
          </GuideLink>
        </Grid>
      );
    });

  return (
    <Grid container spacing={theme!.custom.gridSpacing.default}>
      {renderTravelGuideTiles()}
    </Grid>
  );
};

export const TravelGuideList = withTheme(TravelGuideListComponent);
